import { api } from '../baseApi';
import { makeRequest } from '../makeRequest';
import type { PermissionsDataRequest, PermissionsResponse } from './dto';
import { PermissionAPIRoutes } from './route';

export async function fetchPermissions(params: PermissionsDataRequest): Promise<PermissionsResponse> {
  const result: { response: PermissionsResponse } = await makeRequest(
    api.get(PermissionAPIRoutes.getPermissionData(), { params }),
  );
  return result?.response;
}
